import React, { Suspense, useEffect } from "react";
import ReactDOM from "react-dom";
import { QueryClient, QueryClientProvider } from "react-query";

import "./index.css";

import ProductionScrollable, {
  ProductionErrorBoundary,
} from "./ProductionScrollable";
import PreviewScrollable, { PreviewErrorBoundary } from "./PreviewScrollable";
import { initDatadogScrollable } from "@labxchange/util-datadog";

// Set up content base URL once for the entire app
const projectPath = window.location.pathname.split("/").filter(Boolean).pop();
window.CONTENT_BASE_URL = `${import.meta.env.VITE_CONTENT_BASE_URL}/${projectPath}`;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      suspense: true,
    },
  },
});

const extractProjectFromPath = () => {
  const path = window.location.pathname;
  const segments = path.split("/").filter(Boolean);
  return segments[segments.length - 1];
};

const isPreviewMode = () => {
  return window.location.pathname.includes("/preview-1");
};

const App = () => {
  const query = new URLSearchParams(window.location.search);
  const lang = query.get("lng") || "en";

  useEffect(() => {
    initDatadogScrollable(extractProjectFromPath());
  }, []);

  return (
    <div className={["ar", "ur"].includes(lang) ? "rtl" : ""}>
      {isPreviewMode() ? (
        <PreviewScrollable lang={lang} />
      ) : (
        <ProductionScrollable lang={lang} />
      )}
    </div>
  );
};
const ErrorBoundary = isPreviewMode()
  ? PreviewErrorBoundary
  : ProductionErrorBoundary;
ReactDOM.render(
  <ErrorBoundary>
    <Suspense
      fallback={
        <div className="fallback-loading">
          <div className="loading-animation1">.</div>
          <div className="loading-animation2">.</div>
          <div className="loading-animation3">.</div>
        </div>
      }
    >
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Suspense>
  </ErrorBoundary>,
  document.getElementById("container")
);
